import { Tooltip } from 'antd'

import AtomButton from '@/components/Atoms/AtomButton/AtomButton'

import {
  isStockImportLiveRunAllowed,
  isStockImportTrialRunAllowed,
} from '../../lib/stockImportsRunValidation'
import type { StockImportConfigModel } from '../../types/stockImports.types'
import cn from '../ConfigModal.module.scss'
import type { ConfigStep } from '../lib/configModalTexts'

const TRIAL_RUN_HINT =
  'Загружает файл и подбирает товары без сохранения остатков в каталоге. После проверки результата запустите загрузку с сохранением вручную.'

type ConfigFooterProps = {
  step: ConfigStep
  config: StockImportConfigModel | null
  saving: boolean
  trialLoading: boolean
  runLoading: boolean
  saveDisabled: boolean
  onCancel: () => void
  onBack: () => void
  onTrialRun: () => void
  onLiveRun: () => void
}

function ConfigFooter({
  step,
  config,
  saving,
  trialLoading,
  runLoading,
  saveDisabled,
  onCancel,
  onBack,
  onTrialRun,
  onLiveRun,
}: ConfigFooterProps) {
  const isRunning = trialLoading || runLoading

  return (
    <>
      <AtomButton variant="secondary" disabled={saving} onClick={onCancel}>
        Отмена
      </AtomButton>
      <span className={cn.footerSpacer} />
      {step !== 'source' && (
        <AtomButton variant="secondary" disabled={saving} onClick={onBack}>
          Назад
        </AtomButton>
      )}
      {step !== 'review' ? (
        <AtomButton htmlType="submit">Далее</AtomButton>
      ) : (
        <>
          <Tooltip title={TRIAL_RUN_HINT}>
            <AtomButton
              variant="secondary"
              loading={trialLoading}
              disabled={
                (!!config && !isStockImportTrialRunAllowed(config.status)) ||
                runLoading
              }
              onClick={onTrialRun}
            >
              Пробный запуск
            </AtomButton>
          </Tooltip>
          <AtomButton
            variant="danger"
            loading={runLoading}
            disabled={
              (!!config && !isStockImportLiveRunAllowed(config.status)) ||
              trialLoading
            }
            onClick={onLiveRun}
          >
            Запустить и сохранить
          </AtomButton>
          <AtomButton
            htmlType="submit"
            loading={saving}
            disabled={saveDisabled || isRunning}
          >
            Сохранить
          </AtomButton>
        </>
      )}
    </>
  )
}

export default ConfigFooter
